<template>
    <transition name="el-message-fade">
        <div
        class="main-tip"
        :class="[customClass]"
        :style="style"
        v-show="visible"
        @mouseenter="clearTimer"
        @mouseleave="startTimer"
        >
            <!-- <div class="order-successful-execution-right">
                <div :class="iconSrc"></div>
            </div> -->
            <div class="order-successful-execution-order" :class="iconSrc" v-html="message"></div>
        </div>
    </transition>
</template>

<script type="text/javascript">
export default {
    data: function () {
        return {
            visible: false,
            message: '',
            duration: 2000,
            type: 'info',
            // iconClass: '',
            customClass: '',
            onClose: null,
            // showClose: false,
            closed: false,
            timer: null,
            // top: '30%'
            top: '8%',
            right: '3%'
        }
    },

    computed: {
        iconSrc: function () {
            //  eslint-disable template-curly-spacing
            // return require(`@img/tip-${ this.type }.png`)
            return this.type
        },
        style () {
            // return {'top': this.top}
            return {'top': this.top, 'right': this.right}
        }
    },

    watch: {
        closed: function (newVal) {
            if (newVal) {
                this.visible = false
                this.$el.addEventListener('transitionend', this.destroyElement)
            }
        }
    },

    methods: {
        destroyElement: function () {
            this.$el.removeEventListener('transitionend', this.destroyElement)
            this.$destroy(true)
            this.$el.parentNode.removeChild(this.$el)
        },

        close: function () {
            this.closed = true
            if (typeof this.onClose === 'function') {
                this.onClose(this)
            }
        },

        clearTimer: function () {
            clearTimeout(this.timer)
        },

        startTimer: function () {
            var self = this
            if (this.duration > 0) {
                this.timer = setTimeout(function () {
                    if (!self.closed) {
                        self.close()
                    }
                }, this.duration)
            }
        }
    },

    mounted: function () {
        this.startTimer()
    }
}
</script>
<style lang="scss" scoped>
    @import '../../scss/common/tip.scss';

    .el-message-fade-enter-active {
        animation: fold-in 0.5s;
    }
    .el-message-fade-leave-active {
        animation: fold-out 0.5s;
    }
    @keyframes fold-in {
        0% {
            transform: translate(103%, 0);
            opacity: 0;
        }
        100% {
            transform: translate(0, 0);
            opacity: 1;
        }
    }
    @keyframes fold-out {
        0% {
            transform: translate(0, 0);
            opacity: 1;
        }
        100% {
            transform: translate(103%, 0);
            opacity: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/lib/tip.vue